"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavMenu = exports.NavMenuPanel = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactDomInteractions = require("@floating-ui/react-dom-interactions");

var _theming = require("@storybook/theming");

var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));

var _Menu = require("../Menu/Menu");

var _NavMenuButton = require("./NavMenuButton");

var _excluded = ["children", "label", "active", "inverse", "monochrome"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var NavMenuPanel = ( /*#__PURE__*/0, _theming.styled)(_Menu.MenuPanel, process.env.NODE_ENV === "production" ? {
  target: "e1spsvqh0"
} : {
  target: "e1spsvqh0",
  label: "NavMenuPanel"
})(process.env.NODE_ENV === "production" ? {
  name: "1sppo8f",
  styles: "padding:12px;width:288px"
} : {
  name: "1sppo8f",
  styles: "padding:12px;width:288px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
exports.NavMenuPanel = NavMenuPanel;
var NavMenu = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      label = _ref.label,
      active = _ref.active,
      inverse = _ref.inverse,
      monochrome = _ref.monochrome,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      activeIndex = _useState4[0],
      setActiveIndex = _useState4[1];

  var listItemsRef = (0, _react.useRef)([]);
  var listContentRef = (0, _react.useRef)(_react.Children.map(children, function (child) {
    return /*#__PURE__*/(0, _react.isValidElement)(child) ? child.props.label : null;
  }));
  var nodeId = (0, _reactDomInteractions.useFloatingNodeId)();

  var _useFloating = (0, _reactDomInteractions.useFloating)({
    open: open,
    onOpenChange: setOpen,
    middleware: [(0, _reactDomInteractions.offset)({
      mainAxis: 4,
      alignmentAxis: 0
    }), (0, _reactDomInteractions.flip)(), (0, _reactDomInteractions.shift)()],
    placement: 'bottom-start',
    nodeId: nodeId,
    whileElementsMounted: _reactDomInteractions.autoUpdate
  }),
      x = _useFloating.x,
      y = _useFloating.y,
      reference = _useFloating.reference,
      floating = _useFloating.floating,
      strategy = _useFloating.strategy,
      context = _useFloating.context;

  var _useInteractions = (0, _reactDomInteractions.useInteractions)([(0, _reactDomInteractions.useClick)(context, {
    toggle: true,
    ignoreMouse: false
  }), (0, _reactDomInteractions.useRole)(context, {
    role: 'menu'
  }), (0, _reactDomInteractions.useDismiss)(context), (0, _reactDomInteractions.useListNavigation)(context, {
    listRef: listItemsRef,
    activeIndex: activeIndex,
    onNavigate: setActiveIndex,
    loop: true,
    openOnArrowKeyDown: true
  }), (0, _reactDomInteractions.useTypeahead)(context, {
    listRef: listContentRef,
    onMatch: open ? setActiveIndex : undefined,
    activeIndex: activeIndex
  })]),
      getReferenceProps = _useInteractions.getReferenceProps,
      getFloatingProps = _useInteractions.getFloatingProps,
      getItemProps = _useInteractions.getItemProps;

  var mergedReferenceRef = (0, _react.useMemo)(function () {
    return (0, _reactMergeRefs["default"])([ref, reference]);
  }, [reference, ref]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_NavMenuButton.NavMenuButton, (0, _extends2["default"])({
    active: active,
    inverse: inverse,
    monochrome: monochrome,
    open: open
  }, getReferenceProps(_objectSpread(_objectSpread({}, props), {}, {
    ref: mergedReferenceRef,
    onClick: function onClick(event) {
      event.stopPropagation();
      event.currentTarget.focus();
    }
  }))), label), /*#__PURE__*/_react["default"].createElement(_reactDomInteractions.FloatingPortal, null, open && /*#__PURE__*/_react["default"].createElement(_reactDomInteractions.FloatingFocusManager, {
    context: context,
    modal: true // Touch-based screen readers will be able to navigate back to the
    // reference and click it to dismiss the menu without clicking an item.
    // This acts as a touch-based `Esc` key. A visually-hidden dismiss button
    // is an alternative.
    ,
    order: ['reference', 'content']
  }, /*#__PURE__*/_react["default"].createElement(NavMenuPanel, getFloatingProps({
    ref: floating,
    style: {
      position: strategy,
      top: y !== null && y !== void 0 ? y : 0,
      left: x !== null && x !== void 0 ? x : 0,
      transformOrigin: 'top left'
    }
  }), _react.Children.map(children, function (child, index) {
    return /*#__PURE__*/(0, _react.isValidElement)(child) && /*#__PURE__*/(0, _react.cloneElement)(child, getItemProps({
      role: 'menuitem',
      ref: function ref(node) {
        listItemsRef.current[index] = node;
      },
      onClick: function onClick() {
        setOpen(false);
      }
    }));
  })))));
});
exports.NavMenu = NavMenu;
NavMenu.displayName = 'NavMenu';